module.exports = __webpack_public_path__ + "static/media/upgrade-standard-search.8f589f9f.png";